import React from "react";
import { RoundBorderComponentContainer } from "@components/templates/layouts/round-border-component-container/round-border-component-container";
import Spinner from "@components/atoms/spinner/spinner";
import { MainContainer } from "@components/templates/layouts/main-container/main-container";
import { Spacer16 } from "@components/atoms/spacer-16/spacer-16";

export const SpinnerPage = () => {
  return (
    <MainContainer>
      <Spacer16 />
      <RoundBorderComponentContainer>
        <Spinner />
      </RoundBorderComponentContainer>
    </MainContainer>
  );
};
